export class Programme {

  programmeId: number;
  code: string;
  nom: string;
  diplome: string;
  isActif: boolean;
}
